// components/HeroSection.jsx
import React from "react";

const HeroSection = () => {
  return (
    <>
      <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white text-center pt-20 md:pt-40">
        About Multify
      </h2>
      <p className="text-base md:text-lg text-center text-gray-300 mb-8 md:mb-16 pt-5 md:pt-10 w-full sm:w-11/12 md:w-4/5 mx-auto px-4">
        At Multify, we are committed to transforming how businesses in Central
        India manage data and IT infrastructure.
        <br className="hidden md:block" /> Based in Raipur, Chhattisgarh, we are proud to be the region's
        first premier data center, offering cutting-edge solutions that address
        local needs while adhering to global standards.
      </p>
    </>
  );
};

export default HeroSection;